<template>
  <LmDialog v-model="dialog" title="Set google account email" v-bind="$attrs">
    <template #toolbar-actions>
      <q-btn
        :loading="loading"
        :disable="gaeRequiredButNotPresent"
        color="tertiary"
        size="sm"
        class="q-mr-xs"
        @click="onSave"
      >
        Save
      </q-btn>
    </template>

    <template #content>
      <q-card-section>
        <q-input
          v-model.trim="gae"
          autofocus
          :disable="loading"
          outlined
          label="Google account email"
          @keyup.enter="onSave"
        />

        <Banner class="q-mt-lg">
          We use Google spreadsheets for data importing and updating functionality. To support that, we need your Google
          account email in order to give you permission to access the data spreadsheet. If you do not already have a
          Google account or wish to use an alternative one, follow the steps here to setup a Google account
          <a href="https://support.google.com/accounts/answer/27441?hl=en#" target="_blank" rel="noopener">
            https://support.google.com/accounts/answer/27441?hl=en#
          </a>
          .
          <br /><br />
          You can remove your Google account email by going to User settings in System settings, clicking on the Google
          icon, and clearing your email from the input box. This will stop sharing the data spreadsheet with the email
          account.
        </Banner>
      </q-card-section>
    </template>
  </LmDialog>
</template>

<script>
import * as apiTo from '@/modular-api'
// Components
import LmDialog from '@/reusable/base-components/LmDialog/LmDialog'

export default {
  components: {
    LmDialog
  },

  props: {
    value: {
      type: Boolean,
      required: true
    },

    user: Object,

    gaeRequired: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  data: () => ({
    gae: null,
    loading: false
  }),

  computed: {
    gaeRequiredButNotPresent() {
      return this.gaeRequired && !this.gae
    },
    dialog: {
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit('input', newVal)
      }
    }
  },

  watch: {
    dialog(val) {
      if (val) this.gae = this.user.google_account_email
    }
  },

  methods: {
    onSave() {
      if (this.gaeRequiredButNotPresent) return
      this.loading = true
      apiTo
        .UPDATE_GAE(this.user.id, { google_account_email: this.gae })
        .then(() => {
          this.$emit('updated', { ...this.user, google_account_email: this.gae })
          this.dialog = false
        })
        .finally(() => (this.loading = false))
    }
  }
}
</script>
